(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["premiere-cart-nl-optin"] && !Shopify.designMode) return;
  try {
    class PremiereCartNlOptin extends HTMLElement {
    connectedCallback() {
      this._debug = this.dataset.debug === 'true';
      this._log('connected — session =', this._readState(), '| elements =', document.querySelectorAll('premiere-cart-nl-optin').length);
      this._applyState('connect');
      // The cart can morph our subtree right after connect (drawer open / initial
      // render) without emitting cart:update, resetting the checkbox. Re-assert on
      // the next frame, and observe the subtree so any later morph is corrected.
      requestAnimationFrame(() => this._applyState('raf'));
      if (!this._observer) {
        this._observer = new MutationObserver(() => this._applyState('mutation'));
        this._observer.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['checked'],
        });
      }

      // Persist on toggle. Delegated on the host so it survives the input being
      // morphed/replaced by the cart Section Rendering.
      if (!this._changeBound) {
        this._changeBound = true;
        this.addEventListener('change', (event) => {
          const input = event.target;
          if (input && input.matches && input.matches('input[type="checkbox"]')) {
            this._writeState(input.checked);
            this._log('checkbox changed ->', input.checked);
          }
        });
      }

      // The cart drawer morphs on every cart:update, resetting the checkbox to
      // the server HTML (unchecked) without re-running connectedCallback.
      // Re-apply the stored state on the next frame, after the morph completes.
      if (!this._cartUpdateBound) {
        this._cartUpdateBound = true;
        this._onCartUpdate = () => requestAnimationFrame(() => this._applyState('cart:update'));
        document.addEventListener('cart:update', this._onCartUpdate);
      }

      const form = document.getElementById('cart-form');
      if (form && form.dataset.nlOptinBound !== '1') {
        form.dataset.nlOptinBound = '1';
        form.addEventListener('submit', (event) => this._onSubmit(event), { capture: true });
        this._log('submit listener bound on #cart-form');
      } else if (!form) {
        this._log('WARN: #cart-form not found at mount');
      }
    }

    disconnectedCallback() {
      this._log('disconnected');
      if (this._onCartUpdate) {
        document.removeEventListener('cart:update', this._onCartUpdate);
        this._cartUpdateBound = false;
      }
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    _applyState(origin) {
      const input = this.querySelector('input[type="checkbox"]');
      if (!input) return;
      input.checked = this._readState() === '1';
      this._log('state applied [' + (origin || 'connect') + '] -> checked =', input.checked);
    }

    _writeState(checked) {
      try {
        sessionStorage.setItem('premiere_cart_nl_optin', checked ? '1' : '0');
      } catch (e) {
        this._log('sessionStorage write failed', e);
      }
    }

    _onSubmit(event) {
      const submitter = event.submitter;
      if (submitter && submitter.id !== 'checkout') {
        this._log('ignored: not the checkout button', { submitterId: submitter.id });
        return;
      }
      const el = document.querySelector('premiere-cart-nl-optin');
      const input = el && el.querySelector('input[type="checkbox"]');
      this._log('cart-form submit fired', { submitterId: submitter && submitter.id, checked: !!(input && input.checked) });
      if (!el || !input || !input.checked) {
        this._log('checkbox not checked -> no opt-in');
        return;
      }
      this._fireOptin(el.dataset.customerEmail, el.dataset.listId);
    }

    _fireOptin(email, listId) {
      if (!email || !listId) {
        this._log('WARN: missing email or listId', { email, listId });
        return;
      }
      const url = `${this.dataset.apiPrefix || '/apps/premiere'}/nl-subscribe-list`;
      const payload = JSON.stringify({ email, list_id: listId });
      this._log('firing opt-in ->', url, payload);
      try {
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: payload,
          keepalive: true,
        })
          .then((res) => this._log('opt-in response', res.status))
          .catch((err) => this._log('opt-in fetch error', err));
      } catch (e) {
        this._log('keepalive unavailable, sendBeacon fallback', e);
        try {
          navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
        } catch (e2) {
          this._log('sendBeacon failed', e2);
        }
      }
    }

    _readState() {
      try {
        return sessionStorage.getItem('premiere_cart_nl_optin');
      } catch (e) {
        return null;
      }
    }

    _log() {
      if (!this._debug) return;
      console.log('[premiere-cart-nl-optin]', ...arguments);
    }
  }

  if (!customElements.get('premiere-cart-nl-optin')) {
    customElements.define('premiere-cart-nl-optin', PremiereCartNlOptin);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premiere-inscription-form"] && !Shopify.designMode) return;
  try {
    class PremiereInscriptionForm extends HTMLElement {
    constructor() {
      super();
      this._buttonCta = null;
      this._buttonSubscribed = null;
      this._error = null;
    }

    connectedCallback() {
      this._buttonCta = this.querySelector('[data-state="cta"]');
      this._buttonSubscribed = this.querySelector('[data-state="subscribed"]');
      this._error = this.querySelector('[data-form-error]');

      if (this._buttonCta) {
        this._buttonCta.addEventListener('click', this._handleSubscribe.bind(this));
      }
      if (this._buttonSubscribed) {
        this._buttonSubscribed.addEventListener('click', this._handleUnsubscribe.bind(this));
      }

      this._fetchStatus();
      console.log('[premiere-inscription-form] connected', {
        collectionId: this._collectionId,
        email: this._customerEmail,
        state: this.dataset.currentState,
      });
    }

    get _collectionId() {
      return this.dataset.collectionId;
    }

    get _customerEmail() {
      return this.dataset.customerEmail;
    }

    async _fetchStatus() {
      if (!this._collectionId || !this._customerEmail) return;
      const url =
        `${this.dataset.apiPrefix || '/apps/premiere'}/nl-subscription-status?email=` +
        encodeURIComponent(this._customerEmail) +
        '&collection_id=' +
        encodeURIComponent(this._collectionId);
      try {
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const json = await res.json();
        if (json && json.subscribed === true) {
          this._showSubscribed({ skipIntroSync: false });
        }
      } catch (_err) {
        // Network error → keep default CTA state.
      }
    }

    async _handleSubscribe() {
      if (!this._collectionId || !this._customerEmail) {
        this._showError(this.dataset.errorGeneric);
        return;
      }
      this._buttonCta.disabled = true;
      this._hideError();

      try {
        const res = await fetch(`${this.dataset.apiPrefix || '/apps/premiere'}/nl-subscribe`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            email: this._customerEmail,
            collection_id: this._collectionId,
          }),
        });

        if (res.ok || res.status === 201) {
          this._showSubscribed();
          return;
        }
        this._showError(this.dataset.errorGeneric);
      } catch (_err) {
        this._showError(this.dataset.errorNetwork);
      } finally {
        this._buttonCta.disabled = false;
      }
    }

    async _handleUnsubscribe() {
      if (!this._collectionId || !this._customerEmail) {
        this._showError(this.dataset.errorGeneric);
        return;
      }
      this._buttonSubscribed.disabled = true;
      this._hideError();

      try {
        const res = await fetch(`${this.dataset.apiPrefix || '/apps/premiere'}/nl-unsubscribe`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            email: this._customerEmail,
            collection_id: this._collectionId,
          }),
        });

        if (res.ok || res.status === 200 || res.status === 204) {
          this._showCta();
          return;
        }
        this._showError(this.dataset.errorGeneric);
      } catch (_err) {
        this._showError(this.dataset.errorNetwork);
      } finally {
        this._buttonSubscribed.disabled = false;
      }
    }

    _showSubscribed() {
      if (this._buttonCta) this._buttonCta.hidden = true;
      if (this._buttonSubscribed) this._buttonSubscribed.hidden = false;
      this.dataset.currentState = 'subscribed';
      this._toggleIntros(true);
      this._hideError();
      console.log('[premiere-inscription-form] showSubscribed');
    }

    _showCta() {
      if (this._buttonSubscribed) this._buttonSubscribed.hidden = true;
      if (this._buttonCta) this._buttonCta.hidden = false;
      this.dataset.currentState = 'cta';
      this._toggleIntros(false);
      this._hideError();
      console.log('[premiere-inscription-form] showCta');
    }

    _toggleIntros(subscribed) {
      const pre = document.querySelector('[data-inscription-intro-pre]');
      const post = document.querySelector('[data-inscription-intro-post]');
      if (pre) pre.hidden = subscribed === true;
      if (post) post.hidden = subscribed !== true;
    }

    _showError(text) {
      if (!this._error) return;
      this._error.textContent = text || '';
      this._error.hidden = false;
    }

    _hideError() {
      if (!this._error) return;
      this._error.hidden = true;
      this._error.textContent = '';
    }
  }

  if (!customElements.get('premiere-inscription-form')) {
    customElements.define('premiere-inscription-form', PremiereInscriptionForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premiere-invitations-form"] && !Shopify.designMode) return;
  try {
    class PremiereInvitationsForm extends HTMLElement {
    constructor() {
      super();
      this._form = null;
      this._submit = null;
      this._error = null;
      this._sentList = null;
      this._container = null;
      this._slotLabel = null;
      this._maxReachedTemplate = null;
    }

    connectedCallback() {
      this._sentList = this.querySelector('[data-sent-list]');
      this._container = this.querySelector('[data-form-container]');
      this._maxReachedTemplate = this.querySelector('[data-max-reached-template]');
      this._bindForm();
    }

    _bindForm() {
      this._form = this.querySelector('[data-invitation-form]');
      if (!this._form) return;
      this._submit = this._form.querySelector('[data-submit]');
      this._error = this._form.querySelector('[data-form-error]');
      this._slotLabel = this._form.querySelector('[data-slot-label]');
      this._form.addEventListener('submit', this._handleSubmit.bind(this));

      const self = this;
      this._form.querySelectorAll('.premiere-invitations-form__input').forEach(function (input) {
        input.addEventListener('input', function () {
          input.classList.remove('premiere-invitations-form__input--invalid');
          input.removeAttribute('aria-invalid');
          const errorEl = self._form.querySelector('[data-field-error="' + input.getAttribute('name') + '"]');
          if (errorEl) {
            errorEl.textContent = '';
            errorEl.hidden = true;
          }
        });
      });
    }

    get _collectionId() {
      return this.dataset.collectionId;
    }

    get _quota() {
      return parseInt(this.dataset.quota, 10) || 0;
    }

    get _sentCount() {
      return this._sentList ? this._sentList.children.length : 0;
    }

    get _remaining() {
      return Math.max(0, this._quota - this._sentCount);
    }

    async _handleSubmit(event) {
      event.preventDefault();
      if (!this._collectionId) return;

      const data = new FormData(this._form);
      const firstName = (data.get('first_name') || '').toString().trim();
      const lastName = (data.get('last_name') || '').toString().trim();
      const email = (data.get('email') || '').toString().trim();

      this._clearFieldErrors();
      this._error.hidden = true;
      this._error.textContent = '';

      const fieldErrors = [];
      if (!lastName) {
        fieldErrors.push({ field: 'last_name', message: this.dataset.errorLastNameRequired });
      }
      if (!firstName) {
        fieldErrors.push({ field: 'first_name', message: this.dataset.errorFirstNameRequired });
      }
      if (!email) {
        fieldErrors.push({ field: 'email', message: this.dataset.errorEmailRequired });
      } else if (!PremiereInvitationsForm._isValidEmail(email)) {
        fieldErrors.push({ field: 'email', message: this.dataset.errorEmailInvalid });
      }
      if (fieldErrors.length > 0) {
        this._showFieldErrors(fieldErrors);
        return;
      }

      this._submit.disabled = true;

      let res;
      try {
        res = await fetch(`${this.dataset.apiPrefix || '/apps/premiere'}/invitations`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            collection_id: this._collectionId,
            invitees: [{ first_name: firstName, last_name: lastName, email: email }],
          }),
        });
      } catch (_err) {
        this._showError(this.dataset.errorNetwork);
        return;
      }

      let json = {};
      try {
        json = await res.json();
      } catch (_err) {
        json = {};
      }

      if (!res.ok && res.status !== 201) {
        this._showError(this.dataset.errorGeneric);
        return;
      }

      const result = (json.results && json.results[0]) || {};
      if (result.status !== 'success') {
        const message = this._errorMessageFor(result.error);
        this._showError(message);
        if (result.error === 'quota_exceeded' || result.error === 'concurrent_modification') {
          window.setTimeout(function () { window.location.reload(); }, 1500);
        }
        return;
      }

      this._appendSentInvitation({
        invitationId: result.invitation_id,
        firstName: firstName,
        lastName: lastName,
        email: email,
      });

      const remainingAfter = typeof json.quota_remaining === 'number'
        ? json.quota_remaining
        : this._remaining;

      if (remainingAfter <= 0) {
        this._swapToMaxReached();
      } else {
        this._form.reset();
        this._submit.disabled = false;
        this._updateSlotLabel(this._sentCount + 1);
      }
    }

    _errorMessageFor(code) {
      switch (code) {
        case 'already_invited_by_you':
          return this.dataset.errorAlreadyInvitedByYou;
        case 'already_invited_by_another':
          return this.dataset.errorAlreadyInvitedByAnother;
        case 'quota_exceeded':
          return this.dataset.errorQuotaExceeded;
        case 'concurrent_modification':
          return this.dataset.errorConcurrentModification;
        case 'email_already_exists':
          return this.dataset.errorEmailAlreadyExists;
        default:
          return this.dataset.errorGeneric;
      }
    }

    static _isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    _clearFieldErrors() {
      if (!this._form) return;
      this._form.querySelectorAll('.premiere-invitations-form__input').forEach(function (input) {
        input.classList.remove('premiere-invitations-form__input--invalid');
        input.removeAttribute('aria-invalid');
      });
      this._form.querySelectorAll('[data-field-error]').forEach(function (el) {
        el.textContent = '';
        el.hidden = true;
      });
    }

    _showFieldErrors(errors) {
      let firstInvalid = null;
      const self = this;
      errors.forEach(function (err) {
        const input = self._form.querySelector('[name="' + err.field + '"]');
        const el = self._form.querySelector('[data-field-error="' + err.field + '"]');
        if (input) {
          input.classList.add('premiere-invitations-form__input--invalid');
          input.setAttribute('aria-invalid', 'true');
          if (!firstInvalid) firstInvalid = input;
        }
        if (el) {
          el.textContent = err.message || self.dataset.errorGeneric || '';
          el.hidden = false;
        }
      });
      if (firstInvalid) firstInvalid.focus();
    }

    _showError(message) {
      this._error.textContent = message || this.dataset.errorGeneric || '';
      this._error.hidden = false;
      this._submit.disabled = false;
    }

    _slotText(index) {
      const template = this.dataset.inviteeLabelTemplate || '';
      return template.replace('__INDEX__', String(index));
    }

    _updateSlotLabel(index) {
      if (!this._slotLabel) return;
      this._slotLabel.textContent = this._slotText(index);
    }

    _appendSentInvitation(invitation) {
      const li = document.createElement('li');
      li.className = 'premiere-invitations-form__sent-item';
      if (invitation.invitationId) {
        li.dataset.invitationId = invitation.invitationId;
      }

      const slot = document.createElement('span');
      slot.className = 'premiere-invitations-form__slot';
      slot.textContent = this._slotText(this._sentCount + 1);

      const person = document.createElement('span');
      person.className = 'premiere-invitations-form__person';

      const name = document.createElement('span');
      name.className = 'premiere-invitations-form__name';
      name.textContent = invitation.firstName + ' ' + invitation.lastName.toUpperCase();

      const email = document.createElement('span');
      email.className = 'premiere-invitations-form__email';
      email.textContent = invitation.email;

      person.appendChild(name);
      person.appendChild(email);
      li.appendChild(slot);
      li.appendChild(person);
      this._sentList.appendChild(li);
    }

    _swapToMaxReached() {
      if (!this._container || !this._maxReachedTemplate) return;
      const fragment = this._maxReachedTemplate.content.cloneNode(true);
      this._container.replaceChildren(fragment);
      this._form = null;
      this._submit = null;
      this._error = null;
      this._slotLabel = null;
    }
  }

  if (!customElements.get('premiere-invitations-form')) {
    customElements.define('premiere-invitations-form', PremiereInvitationsForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premiere-nl-cta"] && !Shopify.designMode) return;
  try {
    class PremiereNlCta extends HTMLElement {
    constructor() {
      super();
      this._stateCta = null;
      this._stateSubscribed = null;
      this._button = null;
      this._unsubButton = null;
      this._error = null;
    }

    connectedCallback() {
      this._stateCta = this.querySelector('[data-nl-state="cta"]');
      this._stateSubscribed = this.querySelector('[data-nl-state="subscribed"]');
      this._button = this.querySelector('[data-nl-subscribe]');
      this._unsubButton = this.querySelector('[data-nl-unsubscribe]');
      this._error = this.querySelector('[data-nl-error]');

      if (this._button) {
        this._button.addEventListener('click', this._handleSubscribe.bind(this));
      }
      if (this._unsubButton) {
        this._unsubButton.addEventListener('click', this._handleUnsubscribe.bind(this));
      }

      this._fetchStatus();
    }

    get _collectionId() {
      return this.dataset.collectionId;
    }

    get _customerEmail() {
      return this.dataset.customerEmail;
    }

    async _fetchStatus() {
      if (!this._collectionId || !this._customerEmail) return;
      const url =
        `${this.dataset.apiPrefix || '/apps/premiere'}/nl-subscription-status?email=` +
        encodeURIComponent(this._customerEmail) +
        '&collection_id=' +
        encodeURIComponent(this._collectionId);
      try {
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const json = await res.json();
        if (json && json.subscribed === true) {
          this._showSubscribed();
        }
      } catch (_err) {
        // Network error → keep default CTA visible (idempotent on subscribe).
      }
    }

    async _handleSubscribe() {
      if (!this._collectionId || !this._customerEmail) return;
      this._button.disabled = true;
      this._error.hidden = true;

      try {
        const res = await fetch(`${this.dataset.apiPrefix || '/apps/premiere'}/nl-subscribe`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            email: this._customerEmail,
            collection_id: this._collectionId,
          }),
        });

        if (res.ok || res.status === 201) {
          this._showSubscribed();
          return;
        }

        const data = await res.json().catch(() => ({}));
        this._showError(data.message, 'generic');
      } catch (_err) {
        this._showError(null, 'network');
      } finally {
        this._button.disabled = false;
      }
    }

    async _handleUnsubscribe() {
      if (!this._collectionId || !this._customerEmail) return;
      this._unsubButton.disabled = true;
      this._error.hidden = true;

      try {
        const res = await fetch(`${this.dataset.apiPrefix || '/apps/premiere'}/nl-unsubscribe`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            email: this._customerEmail,
            collection_id: this._collectionId,
          }),
        });

        if (res.ok) {
          this._showCta();
          return;
        }

        const data = await res.json().catch(() => ({}));
        this._showError(data.message, 'generic');
      } catch (_err) {
        this._showError(null, 'network');
      } finally {
        this._unsubButton.disabled = false;
      }
    }

    _showSubscribed() {
      this._stateCta.hidden = true;
      this._stateSubscribed.hidden = false;
      this._error.hidden = true;
    }

    _showCta() {
      this._stateSubscribed.hidden = true;
      this._stateCta.hidden = false;
      this._error.hidden = true;
    }

    _showError(msg, fallbackKey) {
      const fallback = fallbackKey === 'network'
        ? this.dataset.errorNetwork
        : this.dataset.errorGeneric;
      this._error.textContent = typeof msg === 'string' && msg.length > 0
        ? msg
        : (fallback || '');
      this._error.hidden = false;
    }
  }

  if (!customElements.get('premiere-nl-cta')) {
    customElements.define('premiere-nl-cta', PremiereNlCta);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premiere-sort-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    if (e.target.closest('.premiere-sort-drawer__apply')) {
      const drawer = document.getElementById('sort-drawer');
      if (!drawer) return;
      const selected = drawer.querySelector('.premiere-sort-drawer__input:checked');
      if (!selected) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', selected.value);
      window.location.href = url.toString();
    }

    if (e.target.closest('.premiere-sort-drawer__clear')) {
      const url = new URL(window.location.href);
      url.searchParams.delete('sort_by');
      window.location.href = url.toString();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    class PremiereSelect extends HTMLElement {
    connectedCallback() {
      this._trigger = this.querySelector('.premiere-select__trigger');
      this._list = this.querySelector('.premiere-select__list');
      this._native = this.querySelector('.premiere-select__native');
      this._valueEl = this.querySelector('.premiere-select__trigger-value');

      this._trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this._list.hidden ? this._open() : this._close();
      });

      this._list.querySelectorAll('.premiere-select__item').forEach((item) => {
        item.addEventListener('click', () => this._select(item));
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this._close();
      });
    }

    _open() {
      this._list.hidden = false;
      this._trigger.setAttribute('aria-expanded', 'true');
    }

    _close() {
      this._list.hidden = true;
      this._trigger.setAttribute('aria-expanded', 'false');
    }

    _select(item) {
      const value = item.dataset.value;

      this._native.value = value;
      this._native.dispatchEvent(new Event('change', { bubbles: true }));

      this._list.querySelectorAll('.premiere-select__item').forEach((i) => {
        const selected = i === item;
        i.classList.toggle('premiere-select__item--selected', selected);
        i.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      this._valueEl.innerHTML = item.innerHTML;
      this._close();
    }
  }

  if (!customElements.get('premiere-select')) {
    customElements.define('premiere-select', PremiereSelect);
  }
  } catch(e) { console.error(e); }
})();

})();
